"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROADMAP_STATUS_LABELS = exports.RoadmapStatus = void 0;
var RoadmapStatus;
(function (RoadmapStatus) {
    RoadmapStatus["UNDER_CONSIDERATION"] = "under-consideration";
    RoadmapStatus["PLANNED"] = "planned";
    RoadmapStatus["IN_PROGRESS"] = "in-progress";
})(RoadmapStatus || (exports.RoadmapStatus = RoadmapStatus = {}));
exports.ROADMAP_STATUS_LABELS = {
    [RoadmapStatus.UNDER_CONSIDERATION]: 'Under consideration',
    [RoadmapStatus.PLANNED]: 'Planned',
    [RoadmapStatus.IN_PROGRESS]: 'In progress'
};
